<template>
  <div id="depositOfCurrent">
    <div class="GridB0711BEB">
      <span :text="'100元起存，存期內按存款月數和存款金额靠檔計息，一次性存入本金，支持全部提前支取。'" class="textB24E4B66">
        {{$getFormat($t('label.label136'),minValue)}}
      </span>
      <span :text="'計息規則'" class="text0B03976A">
        {{$t('label.label122')}}
      </span>
      <span :text="' 按照存入當日我行APP產品頁面公佈的產品利率'" class="textB24E4B66">
        {{$t('label.label125')}}
      </span>
      <p class="buttonRight">
        <md-button :text="'示例'" :type="'primary'" :round="true" @click="isPopupShow= true">{{$t('btn.btn5')}}</md-button>
      </p>
    </div>
    <div class="GridB0837B9E">
      <div class="Grid83489023">
        <md-button :text="'按钮'" :type="'primary'" :round="true" @click="goBuy">{{$t('label.label132')}}</md-button>
      </div>
    </div>
    <div class="componentArea">
      <md-popup
        v-model="isPopupShow"
        :hasMask="true"
        :mask-closable="true"
        position="top"
      >
        <div class="popArea">
          <p class="popP">
            {{$t('label.label138')}}
            <br>
            {{$getFormat($t('label.label139'),rates[0],rates[1])}}
            <br>
            {{$getFormat($t('label.label140'),rates[2],rates[3])}}
          </p>
          <p class="spanOfP">
            <span>{{$t('label.label133')}}</span>
            <span>{{$t('label.label134')}}</span>
          </p>
          <div class="popStep">
            <md-steps :steps="steps">
              <template slot="unreached">
                <div class="iconOut">
                </div>
              </template>
              <template slot="current">
                <div class="iconOut">
                </div>
              </template>
              <template
                slot="content"
                slot-scope="{ step }"
              >
                <p class="pUp">{{step.name}}</p>
                <p class="pDown">{{step.money}}</p>
              </template>
            </md-steps>
          </div>
        </div>
      </md-popup>
    </div>
  </div>
</template>
<script>
import { Button, FieldItem, InputItem, Slider, Steps, Picker } from '@gidc/mobile'
import { Popup, Dialog } from 'mand-mobile'
import { PREPURINTRATE } from '../../api/smartdeposit'
import { mapGetters } from 'vuex'
export default {
  name: 'depositOfCurrent',
  components: {
    [Button.name]: Button,
    [FieldItem.name]: FieldItem,
    [InputItem.name]: InputItem,
    [Slider.name]: Slider,
    [Popup.name]: Popup,
    [Steps.name]: Steps,
    [Dialog.name]: Dialog,
    [Picker.name]: Picker
  },
  computed: {
    ...mapGetters([
      'RnInfo',
      'buyProInfo'
    ])
  },
  data () {
    return {
      InputItemA380: {
        value: '123'
      },
      Slider21ED: 500,
      isPopupShow: false,
      steps: [
        {
          name: '2020-03-01',
          money: 'MOP10,000.00'
        },
        {
          name: '',
          money: ''
        },
        {
          name: '',
          money: ''
        },
        {
          name: '2020-09-01',
          money: 'MOP10,019.00'
        }
      ],
      rates: [],
      minValue: ''
    }
  },
  methods: {
    goBuy () {
      this.$store.commit('buyProInfo', { ...this.buyProInfo, minValue: this.minValue })
      this.$router.push({ name: 'informationEntryOfCurrent' })
    },
    getRate () {
      console.log('buyProInfo', this.buyProInfo)
      const params = {
        ccy: this.buyProInfo.ccy.value,
        prodType: this.buyProInfo.prodType,
        tranAmtArray: ['10000', '150000', '250000', '500000'],
        depositTerm: 'Y200'
      }
      this.$remote.post(PREPURINTRATE + '?_locale=' + this.$exchangeLang(this.RnInfo.language), params, { headers: { _token_name: this.RnInfo.token, 'x-i18n': this.$exchangeLang(this.RnInfo.language) } })
        .then(res => {
          console.log('res', res)
          const arr = []
          for (const item of res.intRateArray) {
            console.log('item', item)
            if (item.tranAmt === '10000') {
              arr[0] = item.intRate
            } else if (item.tranAmt === '150000') {
              arr[1] = item.intRate
            } else if (item.tranAmt === '250000') {
              arr[2] = item.intRate
            } else if (item.tranAmt === '500000') {
              arr[3] = item.intRate
            }
          }
          this.rates = arr
          console.log('this.rates', this.rates)
        })
    },
    getMinValue () {
      console.log(this.buyProInfo.cycResultList)
      for (const item of this.buyProInfo.cycResultList) {
        if (item.value === this.buyProInfo.ccy.value) {
          this.minValue = item.minValue
          break
        }
      }
    }
  },
  created () {
    // this.contentData = [this.chooseData[0][0].text,this.chooseData[1][0].text,this.chooseData[2][0].text]
    this.getMinValue()
    this.getRate()
    this.$route.meta.title1 = this.buyProInfo.prodDesc
  }
}
</script>
<style lang="stylus">
  #depositOfCurrent{
    .GridB0711BEB{
      .buttonRight{
        display flex
        justify-content  flex-end
        padding  .48rem .1rem 0 0
        .md-button{
          width auto
          height .41rem
        }
        .md-button.primary{
          background #EBF4FF
        }
        .md-button.primary::after{
          content none
        }
        .md-button-content{
          color #0076FF
          font-size .24rem
          font-weight 400
          line-height .33rem
          height .33rem
        }
      }
    }
    .GridB0837B9E{
      .Grid8BF78CD1{
        .Grid72A690B2{
          .md-field-item {
            .md-field-item-content {
              height .4rem
              line-height .4rem
              padding .1rem 0
              min-height 0
              .md-field-item-control {
                color #0C0C0C
                font-size .28rem
                font-weight 400
                line-height .4rem
                .md-field-item-placeholder {
                  color #9E9E9E
                  font-size .28rem
                  font-weight 400
                  line-height .4rem
                  height .4rem
                }
              }
            }
          }
        }
      }
      .Grid8C4A69E8{
        .md-field-item{
          .md-field-item-content{
            min-height 0
            .md-field-item-control{
              .md-input-item-fake{
                height: .6rem;
                line-height .5rem
                span{
                  line-height .5rem
                  height .5rem
                  font-size .36rem
                  font-weight 500
                  color #0C0C0C
                  padding .05rem 0
                }
              }
            }
          }
        }
      }
      .Grid83489023{
        .md-button{
          border-radius .46rem
          height .92rem
          background linear-gradient(135deg, #4792F7 0%, #2B80F4 100%)
          .md-button-content{
            height .5rem
            line-height .5rem
            font-weight 500
            font-size .36rem
          }
        }
      }
    }
    .popArea{
      .md-steps.md-steps-horizontal{
        padding .1rem .4rem 1.5rem
      }
    }
  }
  .md-dialog-body{
    overflow hidden
    padding .3rem
    .md-picker-column-hooks{
      padding 0
    }
  }
</style>
<style lang="stylus" scoped>
  #depositOfCurrent{
    .GridB0711BEB{
      padding .3rem 0.3rem 0
      .textB24E4B66{
        font-size .28rem
        line-height .48rem
        color #0C0C0C
        display block
      }
      .text0B03976A{
        font-size .28rem
        font-weight bold
        line-height .48rem
        color #0C0C0C
        display block
      }
      .textB24E4B66+.text0B03976A{
        padding-top .7rem
      }
    }
    .GridB0837B9E{
      padding 0 .3rem .3rem
      .Grid83489023{
        display:flex;
        flex-direction:row;
        padding .92rem .3rem .3rem
        background-size:100%;
      }
    }
    .componentArea{
      .popArea{
        background-color white
        padding 1.1rem .3rem 0rem
        .popP{
          font-size .24rem
          line-height .4rem
          font-weight 400
          color #1E1E26
          padding-bottom .4rem
        }
        .spanOfP{
          height .4rem
          line-height .4rem
          justify-content space-between
          font-size .28rem
          display flex
          color #2B80F4
          font-weight 500
        }
        .popStep{
          .iconOut{
            width .12rem
            height .12rem
            background #0076FF
            box-shadow 0 0 .02rem .04rem rgb(195,223,255)
            border-radius .06rem
          }
          .pUp{
            font-size .2rem
            height 28px
            line-height 28px
            color #335B8F
            text-align center
            white-space nowrap
          }
          .pDown{
            font-size .2rem
            height 28px
            line-height 28px
            color #335B8F
            text-align center
            white-space nowrap
          }
        }
      }
    }
  }
  .dialogHeader{
    height 1rem
    background: #F9FAFB;
    display flex
    align-items center
    padding 0 .6rem
    .dialogSpan{
      height .4rem
      font-size .28rem
      flex 1
      text-align center
    }
  }
</style>
